// Shared with every Southbag app — the `phc_` key is a public browser token.
export const PALANTIR_KEY = "phc_rStyYsw4wrB8MwXEsPBJjz57uipHycNVwFPaw2m3aYXo";
export const PALANTIR_HOST = "https://palantir.southbag.cc";
export const IDENTITY_ORIGIN = "https://identity.southbag.cc";
